<!-- On a phone the page area already has its padding: the title and the tabs start at its edge. -->
<div class="px-0 pt-2 pb-0 md:p-2 md:pb-0">
  <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Ustawienia OSK</div>
  <p-tabMenu [model]="tabs" [activeItem]="activeTab()"></p-tabMenu>
</div>

<router-outlet></router-outlet>
